import { useMatomo as useTracker } from '@datapunt/matomo-tracker-react';

export default useTracker;
